import { useMemo } from "react";
import { useAuth } from "./useAuth";
import { PERMISSIONS_BY_ROLE, type Permission, type Role } from "../constants/permissions";

type ExternalRole = { RoleId: string; RoleName?: string };

const toRoleIds = (items: Array<string | ExternalRole> | undefined | null): string[] => {
    if (!Array.isArray(items)) return [];
    return items
        .map((item) => (typeof item === "string" ? item : item?.RoleId))
        .filter((id): id is string => Boolean(id));
};

export function useAuthorization() {
    const { roles } = useAuth();

    const normalizedRoles: string[] = useMemo(() => toRoleIds(roles as any), [roles]);

    const can = (permission: Permission): boolean => {
        if (!normalizedRoles.length) return false;
        return normalizedRoles.some((roleId) => PERMISSIONS_BY_ROLE[roleId as Role]?.has(permission));
    };

    const hasRole = (role: Role): boolean => normalizedRoles.includes(role);

    return { can, hasRole, roles: normalizedRoles };
}
